import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "swiper/css";
import "./Deals.css";

const Deals = () => {
  const swiperRef = useRef(null);
  const [timeLeft, setTimeLeft] = useState("");
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ⏰ Countdown timer
  useEffect(() => {
    const getTomorrowMidnight = () => {
      const now = new Date();
      const tomorrow = new Date();
      tomorrow.setDate(now.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      return tomorrow;
    };

    const updateTimer = () => {
      const now = new Date();
      const diff = getTomorrowMidnight() - now;

      if (diff <= 0) {
        setTimeLeft("00 : 00 : 00");
        return;
      }

      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      setTimeLeft(
        `${hours.toString().padStart(2, "0")} : ${minutes
          .toString()
          .padStart(2, "0")} : ${seconds.toString().padStart(2, "0")}`
      );
    };

    updateTimer();
    const timerId = setInterval(updateTimer, 1000);
    return () => clearInterval(timerId);
  }, []);

  // 🌐 Fetch deals data
  useEffect(() => {
    const fetchDeals = async () => {
      try {
        const res = await fetch("https://admin.travelsdata.com/api/DailyDeals");
        const data = await res.json();

        if (data.success && data.data && data.data.Deals) {
          setDeals(data.data.Deals);
        } else {
          setDeals([]);
        }
      } catch (err) {
        console.error("Error fetching deals:", err);
        setError("Failed to fetch deals");
      } finally {
        setLoading(false);
      }
    };

    fetchDeals();
  }, []);

  // 💀 Skeleton slides
  const skeletonSlides = Array(6)
    .fill(0)
    .map((_, index) => (
      <SwiperSlide key={index} style={{ width: 230, marginRight: 24 }}>
        <div className="deals_of_day_cont">
          <div
            className="deal_of_dayy_swiper"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Skeleton circle width={32} height={32} />
              <Skeleton width={60} height={20} />
            </div>
            <Skeleton width={50} height={20} />
          </div>
          <Skeleton height={15} width={80} style={{ margin: "10px 0" }} />
          <div className="deal_of_dayy_Dest">
            <div>
              <Skeleton width={50} height={18} />
            </div>
            <div style={{ textAlign: "end" }}>
              <Skeleton width={50} height={18} />
            </div>
          </div>
        </div>
      </SwiperSlide>
    ));

  return (
    <div className="Deals_TG_Container">
      <Row style={{ padding: "30px 0px 15px 0px" }}>
        <Col>
          <h4 style={{ fontWeight: "700", marginTop: "15px" }}>DAILY DEALS</h4>
        </Col>
        <Col style={{ textAlign: "end" }}>
          <h6 style={{ fontWeight: "600", color: "#1d489f" }}>Closed At</h6>
          <h4 style={{ fontWeight: "700", color: "#f73131" }}>{timeLeft}</h4>
        </Col>
      </Row>

      {error ? (
        <div style={{ textAlign: "center", color: "red" }}>{error}</div>
      ) : deals.length === 0 && !loading ? (
        <div style={{ textAlign: "center", color: "#777" }}>
          No deals available right now.
        </div>
      ) : (
        <Row>
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={20}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop
            modules={[Autoplay]}
            className="mySwiper"
            style={{ paddingBottom: "20px" }}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
          >
            {loading
              ? skeletonSlides
              : deals.map((deal, index) => {
                  const currentDate = new Date().toISOString().split("T")[0]; // format YYYY-MM-DD
                  const dealUrl = `https://Innovate Blues.com/flightList/dest_${deal.destination}*org_${deal.origin}*dep_${currentDate}*arr_${currentDate}*px_1-0-0*jt_1*cbn_2*pi_${deal.code}`;

                  return (
                    <SwiperSlide
                      key={index}
                      style={{ width: 230, marginRight: 24, height: "135px" }}
                    >
                      <div
                        className="deals_of_day_cont"
                        onClick={() => {
                          localStorage.setItem("flight_deals", deal.offer);

                          window.open(dealUrl, "_blank");
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="deal_of_dayy_swiper">
                          <div>
                            <img
                              src={`/Images/AirlineLogo/${deal.code}.gif`}
                              alt={deal.name}
                              style={{ width: "32px", height: "32px" }}
                              onError={(e) => {
                                e.target.src =
                                  "/Images/AirlineLogo/default.gif";
                              }}
                            />
                            <span
                              style={{ fontWeight: "700", marginLeft: "8px" }}
                            >
                              {deal.name.length > 9
                                ? deal.name.slice(0, 9) + ".."
                                : deal.name}

                              {/* {deal.name} */}
                            </span>
                          </div>
                          <span className="deal_flat_off">
                            Flat {deal.offer}% off
                          </span>
                        </div>
                        <div className="deal_of_dayy_Dest">
                          <div>
                            <p className="deal_day_fW">{deal.origin}</p>
                          </div>
                          <div style={{ textAlign: "end" }}>
                            <p className="deal_day_fW">{deal.destination}</p>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
          </Swiper>

          {/* Swiper Controls */}
          {!loading && (
            <>
              <div
                className="custom-next3"
                onClick={() => swiperRef.current?.slideNext()}
              >
                <FaChevronRight />
              </div>
              <div
                className="custom-prev3"
                onClick={() => swiperRef.current?.slidePrev()}
              >
                <FaChevronLeft />
              </div>
            </>
          )}
        </Row>
      )}
    </div>
  );
};

export default Deals;
